module.exports = __webpack_public_path__ + "static/media/verbandkasten_aktiv.a3d24b7a.png";